var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1c4b3b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.5 19a3.5 3.5 0 0 1 -3.5-3.5v-5a3.5 3.5 0 0 1 7 0v5a3.5 3.5 0 0 1 -3.5 3.5zm0-10a1.5 1.5 0 0 0 -1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5a1.5 1.5 0 0 0 -1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 14.52a1 1 0 0 0 -1 1 1.5 1.5 0 0 1 -3 0v-10.02a2.5 2.5 0 0 0 -2.5-2.5h-10a2.5 2.5 0 0 0 -2.5 2.5v11.5a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5v-1.5a1 1 0 0 0 -1-.98zm-14.5 2.48a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm0-4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm0-4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1zm6 8h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2zm0-4h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2zm0-4h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.eec9de842c78418930ee8c5d766cfbf5.svg";
export { ForwardRef as ReactComponent };